import * as yup from 'yup';

type SchemaMap = {
  [key: string]: yup.AnySchema;
};

const validationSchemas: Partial<SchemaMap> = {
  'conveyancy-choice': yup.string().required(),
  price: yup
    .number()
    .transform((o, v) => parseFloat(v.replace(/,/g, '')))
    .typeError('Price must be a number')
    .moreThan(0, 'Price must be at least £1')
    .max(2000000, 'MAX_BUY')
    .required('Price is required'),
  tenure: yup
    .mixed()
    .oneOf(['freehold', 'leasehold'])
    .required('Property type is required'),
  postcode: yup
    .string()
    .uppercase()
    .matches(/^[A-Z]{1,2}[0-9R][0-9A-Z]? ?[0-9][A-Z]{2}$/, {
      message: 'Postcode is not valid',
      excludeEmptyString: true,
    })
    .required('Postcode is required'),
  'buying-position': yup.array(),
  title: yup
    .mixed()
    .oneOf(['Mr', 'Mrs', 'Ms', 'Miss', 'Mx', 'Dr', 'Rev', 'Prof', 'Other'])
    .required('Title is required'),
  firstName: yup.string().min(1).max(50).required('First name is required'),
  lastName: yup.string().min(1).max(50).required('Last name is required'),
  email: yup
    .string()
    .email('Must be a valid email address')
    .min(3)
    .max(50)
    .required('Email is required'),

  telephone: yup
    .string()
    .min(8, 'Telephone must be at least 8 characters')
    .max(20, 'Telephone must not be more than 20 characters')
    .required('Telephone is required'),
  'accept-terms-and-conditions': yup
    .bool()
    .oneOf([true], 'You must agree to the terms and conditions')
    .required(),

  buyPrice: yup
    .number()
    .transform((o, v) => parseFloat(v.replace(/,/g, '')))
    .typeError('!Price must be a number')
    .moreThan(0, 'Price must be at least £1')
    .max(2000000, 'MAX_BUY')
    .required('Price is required'),

  buyTenure: yup
    .mixed()
    .oneOf(['freehold', 'leasehold'])
    .required('Property type is required'),

  buyPostcode: yup
    .string()
    .uppercase()
    .matches(/^[A-Z]{1,2}[0-9R][0-9A-Z]? ?[0-9][A-Z]{2}$/, {
      message: 'Postcode is not valid',
      excludeEmptyString: true,
    })
    .required('Postcode is required'),

  sellPrice: yup
    .number()
    .transform((o, v) => parseFloat(v.replace(/,/g, '')))
    .typeError('Price must be a number')
    .moreThan(0, 'Price must be at least £1')
    .max(2000000, 'MAX_BUY')
    .required('Price is required'),

  sellTenure: yup
    .mixed()
    .oneOf(['freehold', 'leasehold'])
    .required('Property type is required'),

  sellPostcode: yup
    .string()
    .uppercase()
    .matches(/^[A-Z]{1,2}[0-9R][0-9A-Z]? ?[0-9][A-Z]{2}$/, {
      message: 'Postcode is not valid',
      excludeEmptyString: true,
    })
    .required('Postcode is required'),

  checked: yup
    .bool()
    .oneOf([true], 'You must agree to the terms and conditions'),
};

const getValidationSchema = (keys: string[]): yup.ObjectSchema<any> => {
  const filteredSchemas = keys.reduce<SchemaMap>((acc, key) => {
    const schema = validationSchemas[key];
    if (schema) {
      acc[key] = schema;
    }
    return acc;
  }, {} as SchemaMap);

  return yup.object(filteredSchemas);
};

export { getValidationSchema };
